import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { isProjectTypeMember } from "@/core/lib/access";
import { AUDIT_PROJECT_TYPE } from "@/core/lib/constants";
import { DEPARTMENT_PROJECT_TYPES } from "@/core/lib/project-types";
import { denyRouteAccess } from "@/core/lib/route-access";
import { getLatestClassificationTemplateVersionOptions } from "@/openapi/@tanstack/react-query.gen";

export const Route = createFileRoute(
  "/_protected/template-editor/classification-templates/$templateId/create-version",
)({
  validateSearch: z.object({
    projectType: z.enum(DEPARTMENT_PROJECT_TYPES).optional(),
  }),
  beforeLoad: ({ context, search, params, ...guard }) => {
    const projectType = search.projectType ?? AUDIT_PROJECT_TYPE;
    if (!isProjectTypeMember(context.user, projectType)) {
      denyRouteAccess(guard, `${projectType}_membership`);
    }
    if (!search.projectType) {
      throw redirect({
        to: "/template-editor/classification-templates/$templateId/create-version",
        params,
        search: { projectType },
        replace: true,
      });
    }
  },
  loader: async ({ context: { queryClient, ...context }, params }) => {
    const organizationId = context.user.organization?.id;

    if (!organizationId) {
      throw redirect({ to: "/no-organization", throw: true });
    }

    const latestVersion = await queryClient.query({
      ...getLatestClassificationTemplateVersionOptions({
        path: {
          template_id: params.templateId,
          org_id: organizationId,
        },
      }),
    });

    return {
      latestVersion: latestVersion
        ? {
            ...latestVersion,
            allowed_values:
              latestVersion.allowed_values?.map((row, index) => ({
                id: `loaded-${index}`,
                ...row,
              })) ?? [],
          }
        : undefined,
    };
  },
});
